import { createContext, useState, useEffect } from "react";

export const OrderExpressContext = createContext();

export function OrderExpressProvider({ children }) {
    const [expressItems, setExpressItems] = useState([]);
    const [initialized, setInitialized] = useState(false);

    // ⭐⭐⭐ SEÑAL PARA ABRIR ProductInfoModal
    const [openInfoSignal, setOpenInfoSignal] = useState(null);

    const user = JSON.parse(localStorage.getItem("user"));

    // Cargar al iniciar
    useEffect(() => {
        const saved = localStorage.getItem("order_express_items");
        if (saved) setExpressItems(JSON.parse(saved));
        setInitialized(true);
    }, []);

    // Guardar en localStorage — solo después de cargar para no pisar datos guardados
    useEffect(() => {
        if (!initialized) return;
        localStorage.setItem("order_express_items", JSON.stringify(expressItems));
    }, [expressItems, initialized]);

    // Agregar producto
    const addToOrderExpress = (product) => {
        setExpressItems(prev => {
            const exists = prev.find(x => x.idProduct === product.idProduct);

            if (exists) {
                const newQty = exists.qty + product.qty;
                const newSubtotal = (newQty * exists.price).toFixed(4);
                const newTax = exists.payTax
                    ? (Number(newSubtotal) * (user.porcentaje / 100)).toFixed(2)
                    : "0.00";

                return prev.map(x =>
                    x.idProduct === product.idProduct
                        ? { ...x, qty: newQty, subtotal: newSubtotal, tax: newTax }
                        : x
                );
            }

            return [...prev, product];
        });
    };

    return (
        <OrderExpressContext.Provider
            value={{
                expressItems,
                setExpressItems,
                addToOrderExpress,
                openInfoSignal,
                setOpenInfoSignal
            }}
        >
            {children}
        </OrderExpressContext.Provider>
    );
}
